(function () {
  function pad(n) {
    return String(n).padStart(2, '0');
  }

  function setZeros(wrapper) {
    var d = wrapper.querySelector('[data-part="d"]');
    var h = wrapper.querySelector('[data-part="h"]');
    var m = wrapper.querySelector('[data-part="m"]');
    var s = wrapper.querySelector('[data-part="s"]');

    if (d) d.textContent = '00';
    if (h) h.textContent = '00';
    if (m) m.textContent = '00';
    if (s) s.textContent = '00';
  }

  function initTimer(wrapper) {
    if (!wrapper || wrapper.dataset.timerInit === 'true') return;

    var endDate = wrapper.getAttribute('data-end-date');
    var expiredMode = wrapper.getAttribute('data-expired-mode') || 'hide';

    if (!endDate) return;

    function getNewYorkTime(dateString) {
  var parts = dateString.split(/[-T:]/);

  var y = parseInt(parts[0], 10);
  var m = parseInt(parts[1], 10) - 1;
  var d = parseInt(parts[2], 10);
  var h = parseInt(parts[3] || 0, 10);
  var min = parseInt(parts[4] || 0, 10);
  var s = parseInt(parts[5] || 0, 10);

  var utc = Date.UTC(y, m, d, h, min, s);

  var nyOffset = -5 * 60;
  var dstStart = new Date(Date.UTC(y, 2, 14));
  var dstEnd = new Date(Date.UTC(y, 10, 7));
  var now = new Date(utc);

  if (now >= dstStart && now <= dstEnd) {
    nyOffset = -4 * 60;
  }

  return utc - nyOffset * 60000;
}

var endMs = getNewYorkTime(endDate);
    if (isNaN(endMs)) return;

    wrapper.dataset.timerInit = 'true';

    function update() {
      var diff = endMs - Date.now();

      if (diff <= 0) {
        if (expiredMode === 'hide') {
          wrapper.style.display = 'none';
        } else {
          setZeros(wrapper);
        }
        clearInterval(interval);
        return;
      }

      var d = Math.floor(diff / 86400000);
      diff -= d * 86400000;

      var h = Math.floor(diff / 3600000);
      diff -= h * 3600000;

      var m = Math.floor(diff / 60000);
      diff -= m * 60000;

      var s = Math.floor(diff / 1000);

      var dEl = wrapper.querySelector('[data-part="d"]');
      var hEl = wrapper.querySelector('[data-part="h"]');
      var mEl = wrapper.querySelector('[data-part="m"]');
      var sEl = wrapper.querySelector('[data-part="s"]');

      if (dEl) dEl.textContent = pad(d);
      if (hEl) hEl.textContent = pad(h);
      if (mEl) mEl.textContent = pad(m);
      if (sEl) sEl.textContent = pad(s);
    }

    update();
    var interval = setInterval(update, 1000);
  }

  function initAll(scope) {
    var root = scope || document;
    var timers = root.querySelectorAll('[data-timer-maxmax]');
    timers.forEach(initTimer);
  }

  document.addEventListener('DOMContentLoaded', function () {
    initAll(document);
  });

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });

  document.addEventListener('shopify:block:select', function (event) {
    initAll(event.target);
  });
})();